<template>
    <div v-click-outside="hideDropdown" class="relative">
        <div @click.prevent="showDropdown = !showDropdown"
             class="cursor-pointer text-white md:text-brand hover:text-indigo-600 transition duration-300"
             title="Help!">
            <icon-help class="h-6 w-6"></icon-help>
        </div>

        <transition name="slide-fade">
            <div v-show="showDropdown"
                 class="absolute top-8 right-0 bg-white shadow-lg rounded-xl overflow-hidden"
                 style="min-width: 200px; border-top: 3px solid rgb(226, 27, 34)">
                <!-- Notification DropDown Header-->
                <h3 class="p-2 pl-3 text-md leading-6 font-medium text-gray-900">
                    Help
                </h3>

                <div style="max-height: 400px">
                    <ul class="block w-full font-normal">
                        <li>
                            <a target="_blank" href="https://help.redrabbit.zone"
                               class="no-underline cursor-pointer block w-full px-4 py-2 text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                               @click="hideDropdown()">
                                Knowledge Base
                            </a>
                        </li>
                        <li>
                            <p class="cursor-pointer block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                               @click="openSupport">
                                Support
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "HelpList",
    data () {
        return {
            showDropdown: false
        };
    },
    methods: {
        //v-click-outside requires a method call
        hideDropdown () {
            this.showDropdown = false;
        },

        openSupport () {
            FreshworksWidget("show", "launcher"); // Toggle the lower right side FreshDesk widget

            // Give it to the nextTick to boot, then identify the user and open the widget
            this.$nextTick(() => {
                FreshworksWidget("identify", "ticketForm", {
                    name: this.state.user.name,
                    email: this.state.user.email,
                }, {
                    formId: 153000142899 // Ticket Form ID
                });
                FreshworksWidget("open"); // Open the widget
            });
            this.hideDropdown();
        }
    }
};
</script>